<template>
  <div>
    <!--BACKGROUOND OPACITY-->
    <div
      ref="backdrop"
      class="fade modal-backdrop"
      style="display: none;"
    ></div>
    <!--MODAL DIALOG-->
    <div
      ref="modal"
      class="modal fade"
      style="display: none;"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <!--HEADER-->
          <div class="modal-header">
            <h5
              class="modal-title"
              v-text="_trans('Insert campaign code')"
            ></h5>
            <button
              type="button"
              class="close"
              @click="close(-1)"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!--BODY-->
          <div class="modal-body">
            <!--Check customer email-->
            <form @submit.prevent="confirmCode()">
              <input
                v-model="promoCode"
                type="text"
                class="form-control mt-3"
                :placeholder="_trans('campaign code')"
              />
              <button
                type="submit"
                class="btn btn-primary mt-3 d-flex ml-auto"
                v-text="_trans('OK')"
              ></button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {Dau} from "@store/dau";
    import modal from "@configurator/dialogs/_baseModal.vue";

    export default {
        mixins: [modal],
        name: "ModalNewCampaignCode",
        data() {
            return {
                promoCode: ""
            };
        },
        methods: {
            confirmCode() {
                let closeModal = () => {
                    this.response = this.promoCode;
                    this.close(1);
                };
                closeModal();
            }
        }
    };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/configurator/dialogs/modalNewCampaignCode.vue